import _ from 'lodash';
import {action, computed, observable} from 'mobx';
import {DomainObject, oneOf} from 'shared/store';
import {t} from 'shared/core';
import AttachedDocument from './AttachedDocument';
import NotificationRecipient from './NotificationRecipient'

class CompanyDocument extends DomainObject {
  @observable id;
  @observable name = t('models.company_document.DEFAULT_NAME');
  @observable signatureRequired;
  @observable previewFile;
  @observable documentType;
  @observable locale;
  @observable order;
  @observable folderId;
  @observable notificationRecipients = [];

  // PDF Template
  @observable annotations = [];
  @observable originalFile;

  // Rich Text Template
  @observable richText = `<br/>`;
  @observable lexicalState;

  @action merge(other) {
    super.merge(other, {
      previewFile: AttachedDocument,
      originalFile: AttachedDocument,
      notificationRecipients: [NotificationRecipient],
      documentType: oneOf(['rich_text_template', 'pdf_template', 'static_document'])
    });
  }

  @action addRecipient(recipient) {
    this.notificationRecipients.push(recipient);
  }

  @action removeRecipient(recipient) {
    _.remove(this.notificationRecipients, {value: recipient.value});
  }

  @computed get typeView() {
    switch (this.documentType) {
      case 'rich_text_template':
      case 'pdf_template':
      case 'static_document':
        return t(`models.company_document.document_type.${this.documentType}`);
      default:
        throw new Error(`Document type of ${this.documentType} is not supported.`);
    }
  }

  @computed get hasFiles() {
    return !_.isEmpty(this.previewFile);
  }
}

export default CompanyDocument;
